import React from 'react';
import { useEffect, useRef } from 'react';

export const PreezieAI = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!containerRef.current) return;

    const script = document.createElement('script');
    script.src = 'https://widget.shopassistant-ai.com/preguide_ai.js';
    script.setAttribute('data-tenantid', window.Jbhifi.pdpAiAssistanceTenantId);
    script.setAttribute('data-app-type', 'pdp');
    script.defer = true;

    containerRef.current.appendChild(script);

    return () => {
      containerRef.current?.removeChild(script);
    };
  }, []);

  return <div ref={containerRef} />;
};
